import { excelService, type ExcelExportJobResponse } from '@/services/excel.service';
import { downloadBlob } from '@/utils/downloadBlob';

export function downloadExcelBlob(blob: Blob, filename: string): void {
  downloadBlob(blob, filename);
}

// TCR-2500 — kết quả tải: `ok: false` nghĩa là trình duyệt CHẶN mở tab tải
// (window.open trả null — xảy ra khi gọi sau chờ poll, không còn user gesture
// như Chrome sau ~40s). Caller phải giữ nút "Tải xuống" thay vì đóng modal.
export interface DownloadExportJobResult {
  ok: boolean;
}

export async function downloadExcelExportJob(jobOrId: ExcelExportJobResponse | string): Promise<DownloadExportJobResult> {
  const job = typeof jobOrId === 'string'
    ? await excelService.getExportJob(jobOrId)
    : jobOrId;
  const detail = job.download_url ? job : await excelService.getExportJob(job.export_id);

  if (detail.download_url) {
    let win: Window | null = null;
    try {
      win = window.open(detail.download_url, '_blank', 'noopener,noreferrer');
    } catch {
      // Một số trình duyệt ném thay vì trả null khi chặn popup — coi như bị chặn.
      win = null;
    }
    return { ok: win !== null };
  }

  const file = await excelService.downloadExportFile(detail.export_id);
  downloadExcelBlob(file.blob, file.filename);
  return { ok: true };
}

export async function downloadExcelImportErrorFile(importId: string): Promise<void> {
  const blob = await excelService.downloadImportErrorFile(importId);
  downloadExcelBlob(blob, `import-errors-${importId}.xlsx`);
}
